import React from 'react';
import { MonoTag } from '../shared';
import { PAGES_CARDS } from '../data';

const Pages: React.FC<{
  phone?: boolean;
  narrow?: boolean;
  tabletRail?: boolean;
}> = ({ phone, narrow, tabletRail }) => (
  <div
    style={{
      padding: phone ? '28px 20px 20px' : '48px 56px',
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      gap: 26,
      minHeight: 0,
    }}
  >
    <div>
      <h1
        style={{
          margin: '0 0 12px 0',
          fontSize: phone ? 34 : 56,
          fontWeight: 600,
          lineHeight: 0.95,
          letterSpacing: '-.01em',
        }}
      >
        The lay of the <span style={{ color: '#00B061' }}>land.</span>
      </h1>
      <p
        style={{
          margin: 0,
          fontSize: 15,
          color: '#9a9a9a',
          maxWidth: 580,
          lineHeight: 1.6,
        }}
      >
        Where to find what. The dashboard splits into three surfaces — the rest
        is navigation chrome and account settings.
      </p>
    </div>
    <div
      className="no-scrollbar"
      style={{
        flex: 1,
        display: 'flex',
        alignItems: 'flex-start',
        minHeight: 0,
        marginTop: narrow ? 12 : 32,
        overflowY: phone ? 'visible' : 'auto',
        scrollbarWidth: 'none',
      }}
    >
      <div
        style={{
          width: '100%',
          display: 'grid',
          gridTemplateColumns: narrow ? '1fr' : 'repeat(3, 1fr)',
          gap: narrow ? 20 : 32,
        }}
      >
        {PAGES_CARDS.map((c) => (
          <div
            key={c.n}
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: 10,
              borderTop: '2px solid #00B061',
              paddingTop: 20,
            }}
          >
            <div style={{ display: 'flex', alignItems: 'baseline', gap: 10 }}>
              <MonoTag color="#00B061">{c.n}</MonoTag>
              <div style={{ fontSize: tabletRail ? 18 : 22, fontWeight: 600 }}>
                {c.k}
              </div>
            </div>
            <p
              style={{
                margin: 0,
                fontSize: 14,
                color: '#9a9a9a',
                lineHeight: 1.65,
              }}
            >
              {c.body}
            </p>
          </div>
        ))}
      </div>
    </div>
  </div>
);

export default Pages;
